import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  padding: 0 20px;
`;

export const CardContainer = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: 2.4px;
  box-shadow: 0 1px 2px 0 rgba(72, 72, 72, 0.2);
  display: flex;
  height: 30px;
  justify-content: center;
  margin-left: 10px;
  width: 48px;

  :first-child {
    margin-left: 0;
  }

  svg {
    height: 20px;
  }
`;

export const Message = styled.div`
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.colors.textQuote()};
  line-height: 36px;
  position: relative;
  flex-wrap: wrap;

  > span {
    margin-left: 22px;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 0;

  svg {
    fill: ${({ theme }) => theme.colors.textQuote()};
    height: 10px;
    max-width: 12px;
    width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  margin-left: 22px;
`;
